import { useTranslation } from 'react-i18next'

function PrivacyStatementPage() {
  const { t: translate } = useTranslation()

  return (
    <div>
      <div className="text-4xl">{translate('privacy_statement')}</div>
    </div>
  )
}

export default PrivacyStatementPage
